module.exports = __webpack_public_path__ + "img/img37.bcbe5434.png";